module.exports = __webpack_public_path__ + "static/img/4-4.135a597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-4.jpg
// module id = Ncjl
// module chunks = 25